"use client"

import * as React from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { toast } from "sonner"

/**
 * Reads `moduleAccessDenied=1` from the URL, shows a toast, strips the flag (stable id for dedupe).
 */
export function useModuleAccessDeniedToast(message: string) {
  const location = useLocation()
  const navigate = useNavigate()

  React.useEffect(() => {
    const params = new URLSearchParams(location.search)
    if (params.get("moduleAccessDenied") !== "1") return
    toast.info(message, { id: "module-access-denied" })
    params.delete("moduleAccessDenied")
    const nextSearch = params.toString()
    navigate(`${location.pathname}${nextSearch ? `?${nextSearch}` : ""}`, { replace: true })
  }, [location.pathname, location.search, message, navigate])
}
